import type { Episode } from './types'
import EpisodeRow from './EpisodeRow'

type Props = {
  episodes: Episode[]
  selectedIds: Set<string>
  canAdd: boolean
  loading: boolean
  hasMore: boolean
  onAdd: (episode: Episode) => void
  onRemove: (id: string) => void
  onLoadMore: () => void
}

export default function EpisodeList({
  episodes,
  selectedIds,
  canAdd,
  loading,
  hasMore,
  onAdd,
  onRemove,
  onLoadMore,
}: Props) {
  return (
    <div className="episode-list">
      {episodes.length === 0 && !loading && (
        <p className="podcast-empty">No episodes available.</p>
      )}
      <ul className="episode-list__items">
        {episodes.map((ep) => {
          const selected = selectedIds.has(ep.id)
          return (
            <li key={ep.id}>
              <EpisodeRow
                episode={ep}
                selected={selected}
                disabled={!selected && !canAdd}
                onAdd={() => onAdd(ep)}
                onRemove={() => onRemove(ep.id)}
              />
            </li>
          )
        })}
      </ul>
      {loading && <p className="podcast-loading">Loading episodes…</p>}
      {!loading && hasMore && (
        <button type="button" className="btn" onClick={onLoadMore}>
          Load more episodes
        </button>
      )}
    </div>
  )
}
